import type { NodeRenderer } from '@contentful/rich-text-react-renderer';
import React from 'react';

import EmbedYoutube from '../embed-youtube/embed-youtube';
import Table from '../table/table';

import { toEmbedYoutubeProps, toTableProps } from './to-component-props';
import ContentBlocks from '../content-blocks/content-blocks';

const EmbeddedEntryRenderer: NodeRenderer = node => {
  const type = node?.data?.target?.sys?.contentType?.sys?.id;
  switch (type) {
    case 'table': {
      const props = toTableProps(node);
      return props ? (
        <div data-node-type={node.nodeType} className="rich-text__table">
          <Table {...props} />
        </div>
      ) : null;
    }
    case 'youtubeEmbed': {
      const props = toEmbedYoutubeProps(node);
      return props ? (
        <div data-node-type={node.nodeType}>
          <EmbedYoutube {...props} />
        </div>
      ) : null;
    }
    default: {
      if (node.data.target.props) {
        return (
          <div data-node-type={node.nodeType}>
            <ContentBlocks {...node?.data?.target?.props} />
          </div>
        );
      }
      return null;
    }
  }
};

export default EmbeddedEntryRenderer;
